/* Navigation swiper */
/* -------------------------------------------------------------------------------------- */
var swiperNav = new Swiper(".productImagesNavSwiper", {
  spaceBetween: 20,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,
  centeredSlides: false,
  loop: false,
});
/* Feature Images */
/* -------------------------------------------------------------------------------------- */
var swiperImages = new Swiper(".productImagesSwiper", {
  spaceBetween: 10,
  loop: false,
  slidesPerView: 1,
  pagination: {
    el: ".js-product-images-nav-swiper-pagination",
    type: "progressbar",
  },
  navigation: {
    nextEl: ".js-product-images-nav-swiper-button-next",
    prevEl: ".js-product-images-nav-swiper-button-prev",
  },
  thumbs: {
    swiper: swiperNav,
  }
});